import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/services/auth-guard';
import { InternalMemberGuard } from './auth/services/internal-member.guard';
import { MiscellaneousComponent } from './shared/components/miscellaneous/miscellaneous.component';

const routes: Routes = [
  {
    path: 'satisfaction',
    canActivate: [AuthGuard],
    loadChildren: () => import('./satisfaction/satisfaction.module').then(m => m.SatisfactionModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'formations',
    loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
  },
  {
    path: 'reservations',
    loadChildren: () => import('./reservation/reservation.module').then(m => m.ReservationModule),
    canActivate: [AuthGuard, InternalMemberGuard],
  },
  {
    path: 'slides',
    loadChildren: () => import('./slides/slides.module').then(m => m.SlidesModule),
  },
  {
    path: 'me',
    loadChildren: () => import('./me/me.module').then(m => m.MeModule),
  },
  {path: '', redirectTo: 'slides/home', pathMatch: 'full'},
  {path: 'home', redirectTo: 'slides/home', pathMatch: 'full'},
  {path: '404', component: MiscellaneousComponent},
  {path: '**', redirectTo: '404'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'disabled',
    relativeLinkResolution: 'legacy',
  })],
  exports: [RouterModule],
})
export class RoutingModule {
}
